import React from 'react'

import './FormTextArea.css'

function FormTextArea({ className, id, errors, name, ...rest }) {
    return (
        <textarea
            className={`form-text-area ${errors ? 'form-text-area-error ' : null} ${className}`}
            id={id}
            name={name || id}
            {...rest}
        />
    )
}

export default FormTextArea
